import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, AlertTriangle, Users, MapPin, MessageCircle } from 'lucide-react';
import { barriers } from '../../../data/comprehensiveFindingsData';
import './DeeperBarriers.css';

const DeeperBarriers: React.FC = () => {
  // Icon mapping for each barrier
  const barrierIcons = {
    1: Users, // Working Hungry
    2: MessageCircle, // Stigma & Emotional Safety
    3: AlertCircle, // Language Barriers
    4: AlertTriangle, // Unclear Pathways
    5: MapPin, // Transportation & Mobility
  };

  return (
    <div className="tmf-deeper-barriers">
      <div className="tmf-barriers-grid">
        {barriers.map((barrier, index) => {
          const Icon = barrierIcons[barrier.id as keyof typeof barrierIcons];

          return (
            <motion.div
              key={barrier.id}
              className={`tmf-barrier-card barrier-${barrier.color}`}
              initial={{ opacity: 0, y: 60, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.6,
                delay: index * 0.15,
                ease: 'backOut',
              }}
              whileHover={{ scale: 1.03, y: -6 }}
            >
              {/* Icon header */}
              <div className="tmf-barrier-icon-container">
                <Icon className="tmf-barrier-icon" size={28} />
              </div>

              {/* Title and themes */}
              <h4 className="tmf-barrier-title">{barrier.title}</h4>
              <div className="tmf-barrier-themes">
                {barrier.themes.map((theme) => (
                  <span key={theme} className="tmf-barrier-theme-tag">
                    Theme {theme}
                  </span>
                ))}
              </div>

              {/* Description */}
              <p className="tmf-barrier-description">{barrier.description}</p>

              {/* Quotes */}
              {barrier.quotes.length > 0 && (
                <div className="tmf-barrier-quotes">
                  <div className="tmf-barrier-quotes-label">Key Insights:</div>
                  <ul className="tmf-barrier-quotes-list">
                    {barrier.quotes.slice(0, 2).map((quote, idx) => (
                      <li key={idx} className="tmf-barrier-quote-item">
                        {quote}
                      </li>
                    ))}
                  </ul>
                  {barrier.quotes.length > 2 && (
                    <div className="tmf-barrier-more-quotes">
                      +{barrier.quotes.length - 2} more insight{barrier.quotes.length - 2 > 1 ? 's' : ''}
                    </div>
                  )}
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default DeeperBarriers;
